import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import moment from 'moment-timezone';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';

import { Loading } from '../stories/Loading';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const SummaryTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 20,
    border: 2,
    borderColor: theme.palette.common.black,
    borderStyle: 'solid',
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  table: {
    minWidth: 650,
  },
  button: {
    maxWidth: '320px',
    width: '100%',
    marginBottom: '24px',
    marginTop: '24px',
    alignSelf: 'center',
  },
}));

interface AdvanceListDetailsProps {}

const AdvanceListDetails = (props: AdvanceListDetailsProps) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [advanceList, setAdvanceList] = useState<[any]>();
  const [advanceSummary, setAdvanceSummary] = useState<any>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await axios.get(
          `/api/getAdvanceList?listType=combined&fetchOnly=${true}`
        );
        setAdvanceList(response.data.list);
        setAdvanceSummary(response.data.summary);
        setError(undefined);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else if (error) {
    return <div>{error}</div>;
  } else {
    return (
      <div className={classes.root}>
        <h2 className={classes.componentTitle}>Advance List</h2>
        <hr className={classes.separatorLine} />

        <Container
          maxWidth="lg"
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <SummaryTableCell>R No</SummaryTableCell>
                  <SummaryTableCell>G Name</SummaryTableCell>
                  <SummaryTableCell>Check-in</SummaryTableCell>
                  <SummaryTableCell>Adv Paid</SummaryTableCell>
                  <SummaryTableCell>Approx Total ( Rent Only )</SummaryTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {advanceList &&
                  advanceList.map((item) => {
                    const checkinDateStr = moment(item.checkin_date)
                      .tz('Asia/Kolkata')
                      .format('DD/MM/YY');
                    const checkinTime = moment(
                      item.checkin_time,
                      'HH:mm'
                    ).format('hh:mm a');
                    return (
                      <StyledTableRow key={item.room_name}>
                        <StyledTableCell component="th" scope="row">
                          {item.room_name} ({item.reference})
                        </StyledTableCell>
                        <StyledTableCell style={{ maxWidth: '260px' }}>
                          {item.first_name} {item.last_name} ({item.address})
                        </StyledTableCell>
                        <StyledTableCell>
                          {`${checkinDateStr} - ${checkinTime}`}
                        </StyledTableCell>
                        <StyledTableCell>
                          {item.advance_amount_paid}
                        </StyledTableCell>
                        <StyledTableCell>
                          {item.approx_total_amount_str}
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>

        <Container
          maxWidth="lg"
          style={{
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <p
            style={{
              fontSize: '1.2rem',
              textDecoration: 'underline',
              marginBottom: '8px',
            }}
          >
            Today's Summary
          </p>
          {advanceSummary &&
            Object.keys(advanceSummary).map((key) => (
              <p
                style={{
                  fontSize: '1.2rem',
                  marginBottom: '8px',
                  marginTop: '8px',
                }}
              >
                {key} : {advanceSummary[key]}
              </p>
            ))}
        </Container>
      </div>
    );
  }
};

export default AdvanceListDetails;
